var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArcArray(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_6277)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.5 6.5H3.5V9.5H0.5V6.5Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.5 7.5V8.5H1.5V7.5H2.5ZM0.5 6.5V9.5H3.5V6.5H0.5Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 0.5H9.5V3.5H6.5V0.5Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 1.87866L14.1213 3.99998L12 6.1213L9.87868 3.99998L12 1.87866Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.87866 4L3.99998 1.87868L6.1213 4L3.99998 6.12132L1.87866 4Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.5 6.5H15.5V9.5H12.5V6.5Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 9.87868L14.1213 12L12 14.1213L9.87868 12L12 9.87868Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.5 12.5H9.5V15.5H6.5V12.5Z",
    fill: "#626262"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.5H7.5V8.5H8.5V7.5Z",
    fill: "#626262"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_6277"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArcArray);
export default __webpack_public_path__ + "static/media/arc-array.dcd76ed4a9cb0a11643d18db38eef096.svg";
export { ForwardRef as ReactComponent };